import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CATEGORIES } from '../config/categories';
import './Navbar.css';

const Navbar = ({ onCategoryChange, activeCategory }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  const handleCategoryClick = (categoryId) => {
    setIsMobileMenuOpen(false);
    if (onCategoryChange) {
      onCategoryChange(categoryId);
    } else {
      navigate(categoryId === 'all' ? '/' : `/category/${categoryId}`);
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
      <div className="navbar-container">

        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/" className="logo-link">
            <img src="/DTT_Logo.png" alt="DailyTechTrend Logo" className="logo-image" width="80" height="44" fetchPriority="high" />
            <div className="logo-text-group">
              <span className="logo-text">DailyTechTrend</span>
              <span className="logo-tagline">Stay Ahead with AI Tools, Tech Trends &amp; Online Earning Secrets</span>
            </div>
          </Link>
        </div>

        {/* Desktop Category Navigation */}
        <div className="navbar-categories">
          {CATEGORIES.map((category) => (
            <button
              key={category.id}
              className={`navbar-category-pill ${activeCategory === category.id ? 'active' : ''}`}
              onClick={() => handleCategoryClick(category.id)}
              title={category.description}
            >
              <span className="category-name">{category.name}</span>
            </button>
          ))}
        </div>

        {/* Desktop secondary links */}
        <div className="navbar-links">
          <Link to="/about" className="navbar-link">About</Link>
          <Link to="/contact" className="navbar-link navbar-link-contact">Contact</Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <div className="mobile-blog-categories">
            <h3>Topics</h3>
            <div className="mobile-category-list">
              {CATEGORIES.map((category) => (
                <button
                  key={category.id}
                  className={`mobile-category-item ${activeCategory === category.id ? 'active' : ''}`}
                  onClick={() => handleCategoryClick(category.id)}
                >
                  <span className="mobile-category-icon">{category.icon}</span>
                  <div className="mobile-category-text">
                    <span className="mobile-category-name">{category.name}</span>
                    {category.description && (
                      <span className="mobile-category-desc">{category.description}</span>
                    )}
                  </div>
                  {activeCategory === category.id && (
                    <span className="mobile-category-indicator">✓</span>
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Mobile page links */}
          <div className="mobile-page-links">
            <Link to="/about" className="mobile-page-link" onClick={() => setIsMobileMenuOpen(false)}>About</Link>
            <Link to="/contact" className="mobile-page-link" onClick={() => setIsMobileMenuOpen(false)}>Contact</Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;